// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipientsList {
	display: flex;
	flex-direction: column;
	padding-bottom: 20px;
}

.recipients {
	max-height: 270px;
	overflow: auto;
	scrollbar-width: thin;
}

.recipients::-webkit-scrollbar {
	width: 5px;
}

.recipients::-webkit-scrollbar-track {
	background: black;
}

.recipients::-webkit-scrollbar-thumb {
	background-color: white;
	border-radius: 6px;
}

.recipientsLoop {
	display: flex;
	align-items: center;
	padding: 5px 0;
}

.showAll {
	color: #b7d423;
	cursor: pointer;
	padding: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/utils/recipients-list.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;AACf","sourcesContent":[".recipientsList {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-bottom: 20px;\n}\n\n.recipients {\n\tmax-height: 270px;\n\toverflow: auto;\n\tscrollbar-width: thin;\n}\n\n.recipients::-webkit-scrollbar {\n\twidth: 5px;\n}\n\n.recipients::-webkit-scrollbar-track {\n\tbackground: black;\n}\n\n.recipients::-webkit-scrollbar-thumb {\n\tbackground-color: white;\n\tborder-radius: 6px;\n}\n\n.recipientsLoop {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 5px 0;\n}\n\n.showAll {\n\tcolor: #b7d423;\n\tcursor: pointer;\n\tpadding: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
